"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  designTokens: true,
  paletteFor: true,
  darkPalette: true,
  lightPalette: true,
  spacing: true,
  radius: true,
  fontSizes: true,
  fontFamily: true,
  gradients: true,
  brand: true,
  statusHues: true,
  gradientStops: true,
  lapColors: true,
  chartTokens: true,
  motion: true,
  focusRing: true,
  elevations: true
};
Object.defineProperty(exports, "brand", {
  enumerable: true,
  get: function () {
    return _primitives.brand;
  }
});
Object.defineProperty(exports, "chartTokens", {
  enumerable: true,
  get: function () {
    return _chart.chartTokens;
  }
});
Object.defineProperty(exports, "darkPalette", {
  enumerable: true,
  get: function () {
    return _dark.darkPalette;
  }
});
exports.designTokens = void 0;
Object.defineProperty(exports, "elevations", {
  enumerable: true,
  get: function () {
    return _effects.elevations;
  }
});
Object.defineProperty(exports, "focusRing", {
  enumerable: true,
  get: function () {
    return _effects.focusRing;
  }
});
Object.defineProperty(exports, "fontFamily", {
  enumerable: true,
  get: function () {
    return _scales.fontFamily;
  }
});
Object.defineProperty(exports, "fontSizes", {
  enumerable: true,
  get: function () {
    return _scales.fontSizes;
  }
});
Object.defineProperty(exports, "gradientStops", {
  enumerable: true,
  get: function () {
    return _primitives.gradientStops;
  }
});
Object.defineProperty(exports, "gradients", {
  enumerable: true,
  get: function () {
    return _gradients.gradients;
  }
});
Object.defineProperty(exports, "lapColors", {
  enumerable: true,
  get: function () {
    return _primitives.lapColors;
  }
});
Object.defineProperty(exports, "lightPalette", {
  enumerable: true,
  get: function () {
    return _light.lightPalette;
  }
});
Object.defineProperty(exports, "motion", {
  enumerable: true,
  get: function () {
    return _effects.motion;
  }
});
exports.paletteFor = paletteFor;
Object.defineProperty(exports, "radius", {
  enumerable: true,
  get: function () {
    return _scales.radius;
  }
});
Object.defineProperty(exports, "spacing", {
  enumerable: true,
  get: function () {
    return _scales.spacing;
  }
});
Object.defineProperty(exports, "statusHues", {
  enumerable: true,
  get: function () {
    return _primitives.statusHues;
  }
});
var _dark = require("./dark");
var _light = require("./light");
var _scales = require("./scales");
var _gradients = require("./gradients");
var _primitives = require("./primitives");
var _chart = require("./chart");
var _effects = require("./effects");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
/**
 * The single source of truth for PitBrain's visual design, consumed by:
 *  - web: `clientapp/src/design/` (MUI theme adapter)
 *  - mobile: `PitBrain.Mobile/constants/` (React Navigation theme adapter)
 *
 * Change a value here and both apps update.
 */
const designTokens = exports.designTokens = {
  dark: _dark.darkPalette,
  light: _light.lightPalette,
  spacing: _scales.spacing,
  radius: _scales.radius,
  fontSizes: _scales.fontSizes,
  fontFamily: _scales.fontFamily,
  gradients: _gradients.gradients,
  gradientStops: _primitives.gradientStops,
  lapColors: _primitives.lapColors,
  chart: _chart.chartTokens,
  motion: _effects.motion,
  focusRing: _effects.focusRing,
  elevations: _effects.elevations
};
/** Convenience accessor for the semantic palette of a mode. */
function paletteFor(mode) {
  return mode === 'dark' ? _dark.darkPalette : _light.lightPalette;
}